import React from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import VendorOrderSoldTable from './components/VendorOrderSoldTable';

const VendorOrderSold = () => {
  return (
    <ErrorBoundary>
      <VendorOrderSoldTable />
    </ErrorBoundary>
  );
};

export default VendorOrderSold;
